import { MapType } from '@/types';

export const GENERIC_ERROR_MESSAGE = 'Oops! Something went wrong. Please try again later.';
export const EFL_PINCODE = 'efl_pincode';
export const EFL_CART_ID = 'efl_cartId';
export const EFL_COOKIE_ACCEPTANCE = 'efl_cookie_acceptance';
export const EFL_RECENTLY_VIEWED_PRODUCTS = 'efl_recentlyViewedProducts';
export const RECENTLY_VIEWED_PRODUCTS_COUNT = 3;
export const EFL_COOKIE_MORE_INFO_URL = '/privacy-policy';
export const LOGIN_REDIRECT_TO_QUERY = 'redirectTo';
export const IR_WORK_ORDER_QUERY = 'IRWorkOrder';
export const EFL_RECENT_SEARCH = 'efl_recent_search';
export const EFL_POPULAR_LIST = 'efl_popular_list';
export const EFL_PAYMENT_DETAILS = 'efl_payment_details';
export const DOMAIN = 'eurekaforbes.com';
export const PDP_COUPON_MODAL_OPEN = 'openCouponModal';
export const WE_PHONE = 'we_phone';
export const COUNTRY_CODE = '+91';
export const EFL_SALE_ASSIST = 'efl_sale_assist';
export const EXISTING_PREXO_DETAILS = 'efl_prexo_details';
export const PREPAID_SERVICE_BOOKED_SLOT = 'prepaid_service_booked_slot';
export const FOLLOW_UP_REQUEST = 'efl_follow_up_request';
export const PREXO_MAPPING = 'prexo_mapping';
export const COOKIE_BANNER_SHOWN = 'cookie_banner_shown';
export enum DEVICE_STATUS {
  IC = 'IC',
  OC = 'OC',
  IW = 'IW',
  OW = 'OW',
}

export const NOT_FOUND = {
  notFound: true,
};

export enum ECOM_INVENTORY_STATUS {
  OUT_OF_STOCK = 'out_of_stock',
  IN_STOCK = 'in_stock',
  LOW_STOCK = 'low_stock',
}

export const ECOM_INVENTORY_STATUS_MESSAGES: MapType = {
  [ECOM_INVENTORY_STATUS.OUT_OF_STOCK]: 'Out of stock',
  [ECOM_INVENTORY_STATUS.IN_STOCK]: 'In stock',
  [ECOM_INVENTORY_STATUS.LOW_STOCK]: 'Low stock',
};
export const COOKIE_AGE = 86400;
export const UTM_PARAMETERS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_channel',
];
export const ECOM_CHECKOUT_PRODUCT_UNAVAILABLE = 'UNAVAILABLE';
export const E2E_SCORLL_CLASSES = '-mx-6 px-6 lg:mx-0 lg:px-0';

export enum PRODUCT_TYPE {
  AIR_PURIFIER = 'AIR_PURIFIER',
  VACUUM_CLEANER = 'VACUUM_CLEANER',
  WATER_PURIFIER = 'WATER_PURIFIER',
}

export const PREXO_PRODUCT_NAME: MapType = {
  [PRODUCT_TYPE.AIR_PURIFIER]: 'Old Air Purifier',
  [PRODUCT_TYPE.VACUUM_CLEANER]: 'Old Vacuum Cleaner',
  [PRODUCT_TYPE.WATER_PURIFIER]: 'Old Water Purifier',
};

export const GRADIENTS: MapType = {
  blue: 'linear-gradient(127deg, #E8F2FF 10.96%, rgba(232, 242, 255, 0.00) 94.81%)',
};

export enum GATEWAYS {
  PAYU = 'PAYU',
  RAZORPAY = 'RAZORPAY',
}

export enum PLATFORMS {
  WEB = 'web',
  FLUTTER_WEB_VIEW = 'flutter-web-view',
}

export const RESEND_OTP_COUNTDOWN = 30;
export const QA_TSA_APP_ID = 'com.eureka.tsa.qa';
export const PROD_TSA_APP_ID = 'com.eureka.tsa';
